import ApiService from "../../Services/ApiService";

export default {
    state: {
        events: null,
        eventDirtyFlag: false,
    },

    getters: {
        getEvents(state) {
            return state.events;
        },
        getEventDirtyFlag(state) {
            return state.getEventDirtyFlag;
        },
    },

    mutations: {
        setEvents(state, payload) {
            state.events = payload;
            state.eventDirtyFlag = true;
        },
        setEventDirtyFlag(state) {
            state.eventDirtyFlag = false;
        },
    },

    actions: {
        async checkEvents({commit}, user_id) {  // on login and every hour
            const events = (await ApiService.getEvents(user_id)).data;
            console.log('Events----', events);
            if (events.dirtyFlag === true) {
                commit('setEvents', events);
                commit('setEventDirtyFlag');
            }
        },

        async resetEventDirtyFlag({commit}, user_id) {  // run this when user sees Events Dialog
            await ApiService.updateUserSettings(user_id, getEvents(), 'EVENTS');

            commit('setEventDirtyFlag');
        },
    },
};
